/* globals console, document, module, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

module.exports = function (url, jsonpCallbackName, callback) {
    const  scripts = document.getElementsByTagName('script')[0],
        script = document.createElement('script');
    window[jsonpCallbackName] = callback;
    script.type = 'text/javascript';
    script.src = url;
    scripts.parentNode.insertBefore(script, scripts);
};
